export const menuReducer = (state = false, action) => {
    switch (action.type) {
        case "SET_OPEN_MENU":
            return true;
        case "SET_CLOSE_MENU":
            return false;
        default:
            return state;
    }
};
